<template>
  <v-ons-page class="l-content l-contact">
    <custom-toolbar backLabel="Retour">Contact</custom-toolbar>

    <div class="container">
      <div class="infoContent">
        <div class="info">
          <i class="fas fa-building"></i>
          <div class="infoName" v-html="contact.name"></div>
        </div>
        <div class="info">
          <i class="fas fa-phone"></i>
          <div class="infoName">
            <a :href="'tel:' + contact.tel">{{ contact.tel }}</a>
          </div>
        </div>
        <div class="info">
          <i class="fas fa-at"></i>
          <div class="infoName">{{ contact.email }}</div>
        </div>
        <div class="info">
          <i class="fas fa-globe"></i>
          <div class="infoName">{{ contact.web }}</div>
        </div>
      </div>
    </div>
  </v-ons-page>
</template>

<script>
  export default {
    computed: {
      contact() {
        return this.keyholding.contact;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// KeyholdingContact.vue?3b7f3480